<ng-container *transloco="let t">
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">{{ t('delivery_information') }}</h5>
        </div>

        <div class="card-content">
            <ion-list class="divide-y p-0" lines="none">
                <ion-item class="px-0">
                    <tui-svg slot="start" src="svg::shop-2" class="text-blue-500"></tui-svg>
                    <ion-label>
                        <p>{{ t('store') }}</p>
                        <h4 class="!font-medium">{{ order.shop?.address || '-' }}</h4>
                    </ion-label>
                </ion-item>

                <ion-item
                    *ngIf="order.order_type === OrderType.Delivery && (allowLogin() || readonly)"
                    class="px-0"
                    [button]="!readonly"
                    [detail]="!readonly"
                    (click)="handleSelectReceiver()"
                >
                    <tui-svg slot="start" src="svg::map-pin" class="text-green-500"></tui-svg>
                    <ion-label>
                        <p>{{ t('delivery_to') }}</p>
                        <ng-container *ngIf="order.receiver">
                            <h4 class="!font-medium">{{ order.receiver | formattedAddress }}</h4>
                            <h5>{{ order.receiver.name + ' • ' + order.receiver.phone }}</h5>
                        </ng-container>
                        <h4 *ngIf="!order.receiver" class="text-red-500">
                            {{ t('please_select_a_delivery_address') }}
                        </h4>
                    </ion-label>
                </ion-item>

                <ion-item
                    class="px-0"
                    *ngIf="order.order_type === OrderType.Pickup"
                    (click)="showPickupTimeSheet()"
                    [button]="!readonly"
                    [detail]="!readonly"
                >
                    <tui-svg slot="start" src="svg::clock" class="text-orange-500"></tui-svg>
                    <ion-label>
                        <p>{{ t('receiving_time') }}</p>
                        <h4 class="!font-medium">{{ order.booking_time | dfnsParseIso | dfnsFormat : 'p, iiii P' }}</h4>
                    </ion-label>
                </ion-item>
            </ion-list>

            <us-shipment-details
                *ngIf="order.order_type === OrderType.Delivery && !allowLogin() && !readonly"
            ></us-shipment-details>
        </div>
    </div>

    <ng-template [tuiSheetOptions]="options" [(tuiSheet)]="openPickupTimeSheet">
        <h2 tuiSheetHeading>{{ t('select_time') }}</h2>

        <us-select-time
            [min]="now"
            [value]="order.booking_time"
            (valueChange)="handleSelectPickupTime($event)"
        ></us-select-time>
    </ng-template>
</ng-container>
